import DOMPurify from "dompurify";
import { useParams } from "react-router-dom";
import FeaturedTopicsContainer from "../../components/FeaturedTopics/FeaturedTopicsContainer";
import formatSlug from "../../utils/formatSlug";
import gettingStartedArray from "../../utils/gettingStartedArray";

const GettingStartedArticle: React.FC = () => {
  let { title } = useParams();

  let formated = formatSlug(title!, false, false);

  let selected = gettingStartedArray.filter((item) => item.title === formated);

  if (selected.length === 0) {
    formated = formatSlug(title!, false, true);
    selected = gettingStartedArray.filter((item) => item.title === formated);
  }

  const sanitizedData = (props: string | Node) => ({
    __html: DOMPurify.sanitize(props),
  });

  return (
    <div className="article-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132;{" "}
        <a href="/getting-started" className="breadcrumb-link">
          Getting Started
        </a>{" "}
        &#10132; {selected[0].title}
      </p>
      <div className="row">
        <div className="col-article">
          <h2 className="help-heading">{selected[0].title}</h2>
          <p dangerouslySetInnerHTML={sanitizedData(selected[0].content)} />
        </div>
        <div className="col-article-1">
          <FeaturedTopicsContainer />
        </div>
      </div>
    </div>
  );
};

export default GettingStartedArticle;
